import { post } from '../libs/Axios';
import BaseFormComponent from '../abstracts/BaseFormComponent';
import { DataLayerUtils } from '../utilities/DataLayer';

export default class LoginComponent extends BaseFormComponent {
  constructor(element) {
    super(element);
    this.handleSubmit();
  }

  pushDataLayer() {
    DataLayerUtils.push({
      gaHitType: 'event',
      event: 'generic_event',
      eventCategory: 'login_page',
      eventAction: 'click_login'
    });
  }

  handleSubmit() {
    this.onSubmit(async (e, action, formButton) => {
      try {
        this.pushDataLayer();
        this.loading(formButton);
        const formData = this.serializeForm(e.currentTarget).getData('object');
        const { data } = await post(action, { ...formData });
        const {
          success, redirectUrl
        } = data;
        if (success) return window.location.assign(redirectUrl);
        this.endLoading(formButton);
        return data;
      } catch (err) {
        this.endLoading(formButton);
      }
    });
  }
}
